export default Object.freeze({
  ServicioEducativo: 16,
  AsistenteServicio: 17,
  FuncionarioDEPR: 35,
});
